<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12" class="mb-3">
          <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
        </b-col>
        <b-col cols="12">

          <b-form @submit.prevent="updateData">
          <b-card no-body>
            <template v-slot:header>
              <span class="pull-left mt-2 mb-2">{{item.title}}</span>
            </template>
            <b-tabs pills card>
              <b-tab title="Details" active>
                <b-col cols="12" class="mt-2">

                  <b-form-group label="Titel">
                    <b-form-input type="text" required v-model="item.title" :disabled="!editable"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Locatie">
                    <b-form-input type="text" required v-model="item.location" :disabled="!editable"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Issuu link">
                    <b-form-input type="text" required v-model="item.issuu_link" :disabled="!editable"></b-form-input>
                  </b-form-group>

                </b-col>
              </b-tab>

              <b-tab title="Bestanden">
                <project-introductions-upload v-on:uploadedFiles="updateFiles" :options="item.project_mediatypes"/>
                <project-introductions-documents v-on:deletedFile="removeFile" :featured_image="item.featured_image" :images="item.project_introduction_images" :files="item.project_introduction_files"/>
              </b-tab>

            </b-tabs>

            <template v-slot:footer>
              <a class="btn btn-primary pull-left hoverable" @click="editable=true" v-if="!editable">Bewerken</a>
              <a class="btn btn-warning pull-left hoverable" @click="cancelEdit" v-if="editable">Annuleer</a>
              <b-button type="submit" variant="success" class="pull-right" v-if="editable">Opslaan</b-button>
            </template>
          </b-card>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import {getData, updateData} from '@/api';
import ProjectIntroductionsUpload from "@/views/project-introductions/parts/Upload";
import ProjectIntroductionsDocuments from "@/views/project-introductions/parts/Documents";

export default {
  name: 'project-introductions-single',

  components: { ProjectIntroductionsUpload, ProjectIntroductionsDocuments },

  props: ['id'],

  data() {
    return {
      saveButtonDisabled: false,
      feedback: {
        show: false,
        text: '',
        variant: null,
        dismissCountDown: 4
      },
      editable: false,
      item: [],
      errors: null,
    }
  },

  methods: {
    async getItem() {
      const item = await getData('project-introductions/' + this.$route.params.id).then(response => response.data);
      this.item = item.data
    },

    async updateData() {
      const request = await updateData('project-introductions/' + this.$route.params.id, {
        title: this.item.title,
        location: this.item.location,
        issuu_link: this.item.issuu_link,
      }).then(response => response.data);
      this.item = request.data
      this.editable = false;
    },

    cancelEdit() {
      this.getItem();
      this.editable = false;
    },

    updateFiles(data) {
      this.item.project_introduction_images = data.project_introduction_images;
      this.item.project_introduction_files = data.project_introduction_files;
    },

    removeFile(id) {
      this.item.project_introduction_images = this.item.project_introduction_images.filter(file => {
        return file.id != id;
      })

      this.item.project_introduction_files = this.item.project_introduction_files.filter(file => {
        return file.id != id;
      })
    },
  },

  beforeMount() {
    this.getItem();
  },
}

</script>
<style>
</style>
